import { FC, ChangeEvent } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import cx from 'classnames';

import styles from './InputTextarea.module.sass';

interface InputTextareaProps {
  id: string;
  name: string;
  value: string;
  onChange: (newValue: string) => void;
  onBlur: () => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  isError?: boolean;
}

const InputTextarea: FC<InputTextareaProps> = (props) => {
  const {
    value,
    onChange,
    onBlur,
    id = '',
    name = '',
    className = '',
    isError = false,
    readOnly = false,
    disabled = false,
    required = false,
    placeholder = '',
  } = props;

  const changeHandler = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const blurHandler = () => {
    onBlur();
  };

  const textareaClassName = cx(
    className,
    styles.textarea,
    isError && styles.error,
  );

  return (
    <TextareaAutosize
      id={id}
      name={name}
      className={textareaClassName}
      value={value}
      onChange={changeHandler}
      onBlur={blurHandler}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      minRows={1}
    />
  );
};

export default InputTextarea;
